import {Component, OnInit} from '@angular/core';
import {Block, BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-header1',
    templateUrl: './block-header1.component.html',
})

export class BlockHeader1Component extends BlockAbstractComponent implements OnInit {
    pageIcon?: string;

    override ngOnInit() {
        super.ngOnInit();
        this.getPageIcon();
    }

    getPageIcon() {
        this.pageIcon = this.pages?.getCurrentPage()?.meta?.pageIcon;
    }

    parseBlockId(block: Block) {
        if (block.data.isAnchor) {
            return this.block.data.text.toLowerCase().replace(/\s+/g, '-');
        } else {
            return 'heading-' + block.id
        }
    }
}
